// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%;
}
html, body {
  margin: 0;
  padding: 0;
  opacity: 1;
}
body {
  min-height: 100vh;
  color: var(--_18w76bw2g);
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.react-target {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
::placeholder {
  font-size: 1em;
  color: var(--_18w76bw2c);
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
  color: inherit;
}
.product-description ul {
  list-style-type: disc;
  list-style-position: inside;
  margin-left: 1em;
}
.product-description p {
  margin-bottom: 1em;
}
.customScroll {
  scrollbar-width: thin;
  scrollbar-color: #333 #e2e2e2;
}
.customScroll::-webkit-scrollbar {
  width: 5px;
}
.customScroll::-webkit-scrollbar-track {
  background: #e2e2e2;
}
.customScroll::-webkit-scrollbar-thumb {
  background-color: #333;
}
.dangerousHTML-pdpDescription {
  font-family: var(--_18w76bw3n);
  font-size: var(--_18w76bw3s);
  font-weight: var(--_18w76bw3z);
  line-height: var(--_18w76bw48);
}
.dangerousHTML-pdpDescription table {
  margin-bottom: 16px;
}
.dangerousHTML-pdpDescription li {
  margin-bottom: 4px;
}
table {
  border-collapse: collapse;
}
input:-webkit-autofill, input:-webkit-autofill:focus, input:-internal-autofill-selected {
  transition: background-color 600000s 0s, color 600000s 0s;
}
input[data-autocompleted], input:-internal-autofill-selected {
  background-color: var(--_18w76bw26) !important;
}
.disable-pointer-events  a {
  pointer-events: none;
}
.no-body-scrolling {
  max-height: 100vh;
  overflow-y: hidden;
}
@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm) {
  img {
    image-rendering: -webkit-optimize-contrast;
  }
}
@media not all and (min-resolution:.001dpcm) {
  @supports (-webkit-appearance:none) and (stroke-color:transparent) {
    img {
      image-rendering: unset;
    }
  }
}
@media screen and (max-width: 767px) {
  header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: var(--_18w76bw55);
  }
  main {
    margin-top: 96px;
  }
}
@media print {
  footer, header #header-search-and-account-actions {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,8CAA8C;AAChD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,0CAA0C;EAC5C;AACF;AACA;EACE;IACE;MACE,sBAAsB;IACxB;EACF;AACF;AACA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["html {\n  overflow-x: hidden;\n  -webkit-text-size-adjust: 100%;\n}\nhtml, body {\n  margin: 0;\n  padding: 0;\n  opacity: 1;\n}\nbody {\n  min-height: 100vh;\n  color: var(--_18w76bw2g);\n}\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.react-target {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n::placeholder {\n  font-size: 1em;\n  color: var(--_18w76bw2c);\n}\nul {\n  list-style: none;\n}\na {\n  text-decoration: none;\n  color: inherit;\n}\n.product-description ul {\n  list-style-type: disc;\n  list-style-position: inside;\n  margin-left: 1em;\n}\n.product-description p {\n  margin-bottom: 1em;\n}\n.customScroll {\n  scrollbar-width: thin;\n  scrollbar-color: #333 #e2e2e2;\n}\n.customScroll::-webkit-scrollbar {\n  width: 5px;\n}\n.customScroll::-webkit-scrollbar-track {\n  background: #e2e2e2;\n}\n.customScroll::-webkit-scrollbar-thumb {\n  background-color: #333;\n}\n.dangerousHTML-pdpDescription {\n  font-family: var(--_18w76bw3n);\n  font-size: var(--_18w76bw3s);\n  font-weight: var(--_18w76bw3z);\n  line-height: var(--_18w76bw48);\n}\n.dangerousHTML-pdpDescription table {\n  margin-bottom: 16px;\n}\n.dangerousHTML-pdpDescription li {\n  margin-bottom: 4px;\n}\ntable {\n  border-collapse: collapse;\n}\ninput:-webkit-autofill, input:-webkit-autofill:focus, input:-internal-autofill-selected {\n  transition: background-color 600000s 0s, color 600000s 0s;\n}\ninput[data-autocompleted], input:-internal-autofill-selected {\n  background-color: var(--_18w76bw26) !important;\n}\n.disable-pointer-events  a {\n  pointer-events: none;\n}\n.no-body-scrolling {\n  max-height: 100vh;\n  overflow-y: hidden;\n}\n@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm) {\n  img {\n    image-rendering: -webkit-optimize-contrast;\n  }\n}\n@media not all and (min-resolution:.001dpcm) {\n  @supports (-webkit-appearance:none) and (stroke-color:transparent) {\n    img {\n      image-rendering: unset;\n    }\n  }\n}\n@media screen and (max-width: 767px) {\n  header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: var(--_18w76bw55);\n  }\n  main {\n    margin-top: 96px;\n  }\n}\n@media print {\n  footer, header #header-search-and-account-actions {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
